// Message pools for the global loading experience (GlobalLoader / PageLoader).
// Copy rules: plain sentences, verb-first, no filler jargon, no em-dashes.
// Keep pools short (2-4 entries) — messages rotate every ~2.6s and most loads
// finish before the second message.
export const LOADING_MESSAGES = {
	generic: ['Loading your workspace…', 'Getting things ready…', 'Almost there…'],
	search: ['Searching millions of companies…', 'Matching your criteria…', 'Enriching results…'],
	export: ['Preparing your export…', 'Checking for duplicates…', 'Packaging your data…'],
	crm: ['Talking to your CRM…', 'Syncing field mappings…', 'Validating the connection…'],
	dashboard: ['Fetching your credits…', 'Loading your workspace…'],
} as const

export type LoadingContext = keyof typeof LOADING_MESSAGES
